import React, { useState } from 'react';

//@mui
import { Box } from '@mui/material';
import PurchaseBillHistoryList from '../../../components/projectmng/bill_mng/PurchaseBillHistoryList';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listApprovalBuyTaxbills } from '../../../modules/approvalModule/issue-taxbills';
//-----------------------------------------------------

//-----------------------------------------------------

const PurchaseBillHistoryForApproval = ({ docuCd }) => {
  const dispatch = useDispatch();
  const { buyTaxbills } = useSelector(({ approvalModule }) => ({
    buyTaxbills: approvalModule.issueTaxbills.buyTaxbills,
  }));

  const [histories, setHistories] = useState([]);

  useEffect(() => {
    if (docuCd) {
      dispatch(listApprovalBuyTaxbills(docuCd));
    }
  }, [dispatch, docuCd]);

  useEffect(() => {
    if (buyTaxbills) {
      setHistories(buyTaxbills);
    }
  }, [buyTaxbills]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <PurchaseBillHistoryList history={histories} />
    </Box>
  );
};

export default PurchaseBillHistoryForApproval;
